import { bscMainnet } from './bscMainnet';
import { bscTestnet } from './bscTestnet';
import { ethereum } from './ethereum';
import { sepolia } from './sepolia';
import { opBnbMainnet } from './opBnbMainnet';
import { opBnbTestnet } from './opBnbTestnet';
import { arbitrumOne } from './arbitrumOne';
import { arbitrumSepolia } from './arbitrumSepolia';
import { zkSyncMainnet } from './zkSyncMainnet';
import { zkSyncSepolia } from './zkSyncSepolia';
import { optimismMainnet } from './optimismMainnet';
import { optimismSepolia } from './optimismSepolia';
import { baseMainnet } from './baseMainnet';
import { baseSepolia } from './baseSepolia';
import { unichainMainnet } from './unichainMainnet';
import { unichainSepolia } from './unichainSepolia';
import { local } from './local';
import { bittensorTestnet } from './bittensorTestnet';
import { ChainId, type VToken } from '../../types';

export const vTokens: {
  [chainId in ChainId]: VToken[];
} = {
  [ChainId.LOCAL]: local,
  [ChainId.BSC_MAINNET]: bscMainnet,
  [ChainId.BSC_TESTNET]: bscTestnet,
  [ChainId.ETHEREUM]: ethereum,
  [ChainId.SEPOLIA]: sepolia,
  [ChainId.OPBNB_MAINNET]: opBnbMainnet,
  [ChainId.OPBNB_TESTNET]: opBnbTestnet,
  [ChainId.ARBITRUM_ONE]: arbitrumOne,
  [ChainId.ARBITRUM_SEPOLIA]: arbitrumSepolia,
  [ChainId.ZKSYNC_MAINNET]: zkSyncMainnet,
  [ChainId.ZKSYNC_SEPOLIA]: zkSyncSepolia,
  [ChainId.OPTIMISM_MAINNET]: optimismMainnet,
  [ChainId.OPTIMISM_SEPOLIA]: optimismSepolia,
  [ChainId.BASE_MAINNET]: baseMainnet,
  [ChainId.BASE_SEPOLIA]: baseSepolia,
  [ChainId.BITTENSOR_MAINNET]: [],
  [ChainId.BITTENSOR_TESTNET]: bittensorTestnet,
  [ChainId.UNICHAIN_MAINNET]: unichainMainnet,
  [ChainId.UNICHAIN_SEPOLIA]: unichainSepolia,
};
